/*
  Click-and-drag horizontal scrolling for product-card slider rows.
  Only the product image is a real link (navigates on click); starting a
  press anywhere else on a card — title text, price, badges, empty space —
  drags the whole row left/right instead. Pressing on any actual link or
  button (image, quick-add, etc.) is left alone so it still just works.

  Featured-collection rows (.product-grid.slider) additionally get an
  infinite loop: the real slides are cloned once before and once after
  themselves, so the track is [clone][real][clone]. The visible scroll
  position always starts inside the middle (real) block, and whenever a
  drag pushes it into a clone block far enough to be indistinguishable
  from having looped, we silently jump back one block-width — the visual
  content at that position is identical (it's a clone), so the jump is
  invisible. This is re-run on every page load, so scrolling left from a
  fresh page load immediately reveals the end of the row, exactly as if
  the row had already been scrolled around once.
*/
(function () {
  function initInfiniteLoop(container) {
    if (container.__loopInit) return;
    container.__loopInit = true;

    var realItems = Array.prototype.slice.call(container.children);
    if (realItems.length < 2) return;
    // Nothing to loop if the row doesn't actually overflow its box.
    if (container.scrollWidth <= container.clientWidth + 4) return;

    function stripIds(root) {
      if (root.id) root.removeAttribute('id');
      root.querySelectorAll('[id]').forEach(function (node) {
        node.removeAttribute('id');
      });
    }

    function cloneSet() {
      return realItems.map(function (el) {
        var clone = el.cloneNode(true);
        stripIds(clone);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.setAttribute('inert', '');
        clone.style.pointerEvents = 'none';
        return clone;
      });
    }

    var beforeClones = cloneSet();
    var afterClones = cloneSet();

    beforeClones
      .slice()
      .reverse()
      .forEach(function (el) {
        container.insertBefore(el, container.firstChild);
      });
    afterClones.forEach(function (el) {
      container.appendChild(el);
    });

    var blockWidth = container.scrollWidth / 3;
    container.__loopBlockWidth = blockWidth;
    container.scrollLeft = blockWidth;
  }

  function initDragScroll(container) {
    if (container.__dragScrollInit) return;
    container.__dragScrollInit = true;

    if (container.classList.contains('product-grid')) {
      initInfiniteLoop(container);
    }

    var isDown = false;
    var startX = 0;
    var scrollStart = 0;
    var moved = false;

    function loopReposition() {
      var bw = container.__loopBlockWidth;
      if (!bw) return;
      if (container.scrollLeft < bw * 0.5) {
        container.scrollLeft += bw;
        scrollStart += bw;
      } else if (container.scrollLeft > bw * 1.5) {
        container.scrollLeft -= bw;
        scrollStart -= bw;
      }
    }

    container.addEventListener('mousedown', function (e) {
      if (e.target.closest('a[href], button, input, textarea, select, label')) return;

      isDown = true;
      moved = false;
      startX = e.pageX;
      scrollStart = container.scrollLeft;
      container.classList.add('is-drag-scrolling');
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 3) moved = true;
      if (moved) {
        e.preventDefault();
        container.scrollLeft = scrollStart - dx;
        loopReposition();
      }
    });

    window.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      container.classList.remove('is-drag-scrolling');
    });

    // Native scroll sources (trackpad, wheel, momentum) also need to loop,
    // not just an active drag.
    container.addEventListener('scroll', function () {
      if (isDown) return;
      loopReposition();
    });

    // Swallow the click that follows an actual drag so it doesn't
    // accidentally trigger anything (e.g. a badge or price tap target).
    container.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
        moved = false;
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll('.grid.slider, .cj-collection-chips__row').forEach(initDragScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
